import { AfterViewInit, Directive, ElementRef, SkipSelf } from "@angular/core";
import { AffixableHostRef } from "@hex/angular/conduit";

@Directive({
    selector: "hex-dropdown-menu,[conduitMenuSizer]",
})
export class ConduitMenuSizerDirective implements AfterViewInit {
    constructor(
        private elementRef: ElementRef,
        @SkipSelf() private host: AffixableHostRef,
    ) { }

    public ngAfterViewInit() {
        this.setWidth();
    }

    public setWidth() {
        const hostWidth: number = this.host.location.nativeElement.getBoundingClientRect().width;
        const thisWidth: number = this.elementRef.nativeElement.getBoundingClientRect().width;
        if (hostWidth > thisWidth) {
            this.elementRef.nativeElement.style.width = `${hostWidth}px`;
        }
    }
}
